import { SiteSectionItem } from './SiteSectionItem'

type SiteSectionsProps = {
  sections: FooterItem[]
}

export type FooterItem = {
  title?: string
  titleColor?: string
  items: FooterSubItem[]
}

export type FooterSubItem = {
  label?: string
  labelColor?: string
  labelURL?: string
}

export const SiteSections = ({ sections }: SiteSectionsProps) => {
  return sections?.map((el: FooterItem, index: number) => (
    <SiteSectionItem item={el} index={index} key={`footer-sec-${index}`} />
  ))
}
